import React from "react"
import TreeMenu, { TreeMenuProps } from "react-simple-tree-menu"

import { defaultChildren } from "./renderProps"
import { Box, BoxProps } from "@bianic-ui/core"

type Merge<M, N> = Omit<M, Extract<keyof M, keyof N>> & N

export type TreeProps = Merge<BoxProps, TreeMenuProps>

export class Tree extends React.Component<TreeProps> {
  render() {
    const { children, data, hasSearch, ...rest } = this.props
    const child = children || defaultChildren
    const css = `
    .bianic-tree > div:focus {
      outline: none;
      background:#fff;
      
      -webkit-transition: "background .5s ease-out";
      -moz-transition: "background .5s ease-out";
      -o-transition: "background .5s ease-out";
      transition: "background .5s ease-out";
    } 
    `
    return (
      <>
        <style>{css}</style>
        <Box
          className="bianic-tree"
          _focus={{ outline: "none", bg: "#e5e5e550" }}
          outline="none"
          {...rest}
        >
          <Box as={TreeMenu} data={data} hasSearch={hasSearch}>
            {child}
          </Box>
        </Box>
      </>
    )
  }
}
